<template>
    <!-- <aicc-page :titleShow="false" pageId="this.contextPageId"> -->
        <ur-area>
            <div class="wrap">
                <div class="contents_wrap">
                    <section>
                        <div class="contents terms">
                        <h2>AICC Service에 오신 것을 환영합니다.</h2>
                        <p class="terms_txt">AICC Service 사용을 위해 아래 동의가 필요합니다.</p>
                        <div class="checkbox all">
                            <ur-checkbox v-model="chkSome" :checked-icon="selectAllCheckedIcon" @click ="chkAllTerm" medium >본 내용을 읽고 이해하였으며, 전체 동의합니다.</ur-checkbox>
                        </div>
                        <div class="terms_box">
                            <ul>
                            <li v-for="item in termsList" :key="item.termsTypeCode">
                                <div class="check_wrap">
                                    <div v-if="item.termsMandatoryYn === 'Y'" class="checkbox">
                                        <ur-checkbox :value="item.isChecked" v-model="item.isChecked" @input ="isAllChk()" small>{{item.termsName}}(필수)<span class="essential">*</span></ur-checkbox>
                                    </div>
                                    <div v-else class="checkbox">
                                        <ur-checkbox :value="item.isChecked" v-model="item.isChecked" @input ="isAllChk()" small>{{item.termsName}}(선택)</ur-checkbox>
                                    </div>
                                    <ur-button v-if="item.termsMandatoryYn === 'N'" shape="hyperlink" color="default" size="small" @click="showTermDetail(item)">전문보기</ur-button>
                                    <!-- <a  href="#" class="btn_text">전문보기</a> -->
                                </div>
                                <div v-if="item.termsMandatoryYn === 'Y'" class="terms_content" v-html="item.termsContent">
                                </div>
                            </li>
                            </ul>
                        </div>
                        <div class="btn_wrap" align="center">
                            <ur-button solid primary size="large" :disabled="!chkConfirm" @click="agreeTerm()">동의</ur-button>
                        </div>
                        </div>
                    </section>
                </div>
            </div>
            <terms-detail-popup-ext ref="termsDetailPopupExt" :pageId="contextPageId" :pageInitialData="pageInitialData" @closeDetailPopup="closeDetailPopup"/>
        </ur-area>
    <!-- </aicc-page> -->
</template>
<script>
import BasePage from '~cm/components/BasePage';
import AuthManager from '~system/auth/AuthManager';
// import {urDataSet} from 'uidev-component/index.js';
// import urDataGrid from '@uidev/grid/urDataGrid/urDataGrid';
import termsDetailPopupExt from './TermModal.vue';
import ReplyCode from '~modules/AI/js/ReplyCode.js';
import replaceBodyTagWithDivTag from '~common/js/html-util.js';

export default {
    name:'ConfirmPolicy',
    components: {
        termsDetailPopupExt
    },
    data() {
        return {
            chkAll:false, // 전체 선택 여부
            chkSome:false, // 부분 선택 여부
            chkConfirm:false, // 필수 항목 전체 선택 여부
            checkedValues:[],
            termsList:[],
            pageInitialData: {},
            inviteUserInfo: {
                tenantId: '',
                email:'',
            },
        }
    },
    created(){
        // this.$store.state.gnbShowed = false;
        // this.$store.state.lnbShowed = false;
    },
    mounted(){
        console.log("sessionStorage inviteToken", sessionStorage.getItem("inviteToken"));       
        this.getInviteUserInfo(sessionStorage.getItem("inviteToken"));
        console.log(this.$store.state);
        this.$store.state.isGnbMenuShowed = false;
        this.$store.state.lnbShowed = false;
        this.getTermsList();
    },
    destroyed(){
    },
    watch:{},
    computed:{
        contextPageId() {
            if (this._props._params && this._props._params.routerOriginPageId) {
                return this._props._params.routerOriginPageId;
            }
            if(this.$options.name.length > 13) {
                return this.$options.name.substr(0,13);
            }
            return this.$options.name;
        },
        modal() {
            return this.$refs.modal;
        },
        selectAllCheckedIcon() {
            if (this.chkAll) {
                return 'checked'; // 전체 선택
            }

            if (this.chkSome) {
                return 'indeterminate'; // 부분 선택
            }

            return 'box'; // 전체 해제
        },
    },
    methods:{
        getInviteUserInfo(token){    //토큰 이용하여 사용자 초대 정보 조회
            AuthManager.getInviteUserInfo(token).then(data => {                
                if (data.reply.code === ReplyCode.NO_ERROR) { // 성공
                    console.log("성공");                                     
                    this.inviteUserInfo.tenantId=data.inviteUserInfoDVO.tenantId;
                    this.inviteUserInfo.email=data.inviteUserInfoDVO.email;
                    console.log("inviteUserInfo", this.inviteUserInfo);                    
                } else { // 
                    console.warn("실패");            
                }
            }).catch(err => { // 재설정 코드발송 실패
                console.warn(err);            
            });

        },
        getTermsList(){ //약관 정보 조회
            AuthManager.getTermsList().then(data => {                                        
                if (data.reply.code === ReplyCode.NO_ERROR) { // 성공
                    this.termsList = [];
                    for(let index in data.termsList) {
                        this.termsList.push({
                                                termsTypeCode:data.termsList[index].termsTypeCode,
                                                termsVersion:data.termsList[index].termsVersion,
                                                termsName:data.termsList[index].termsName,
                                                termsContent:replaceBodyTagWithDivTag(data.termsList[index].termsContent),
                                                termsMandatoryYn:data.termsList[index].termsMandatoryYn,
                                                isChecked:false,
                                            });
                    }
                    console.log(this.termsList);                    
                } else { // 
                    console.warn("실패");            
                }
            }).catch(err => { // 재설정 코드발송 실패
                console.warn(err);            
            });
        },
        chkAllTerm(){
            if (this.chkAll) { // 전체 선택 -> 전체 해제
                for(let index in this.termsList) {
                    this.termsList[index].isChecked = false;
                }
                this.chkConfirm = false;
            } else { // 부분 선택/전체 해제 -> 전체 선택
                for(let index in this.termsList) {
                    this.termsList[index].isChecked = true;
                }
                this.chkConfirm = true;
            }
            this.$nextTick(() => {
                this.isAllChk();
            });
        },
        isAllChk(){
            let isChk = false;
            for(let index in this.termsList) {
                isChk = this.termsList[index].isChecked;
                if(isChk == false){
                    break;
                }
            }
            this.chkAll = isChk;
            this.chkSome = this.termsList.some(terms => terms.isChecked); // 1개 이상 선택된 경우
            this.chkRequireTerm();
        },
        agreeTerm(){   //약관 동의
            let termsUserListTmp = [];

            for(let index in this.termsList) {
                termsUserListTmp.push({
                    termsTypeCode:this.termsList[index].termsTypeCode,
                    termsVersion:this.termsList[index].termsVersion,
                    isChecked:this.termsList[index].isChecked,
                    tenantId:this.inviteUserInfo.tenantId,
	                usrId:this.inviteUserInfo.email,
                });
            }
            console.log('termsUserListTmp = ', termsUserListTmp);            
            AuthManager.updateTermsList(termsUserListTmp).then(res => {
                console.log("update TermsList res",res);      
                if (res.reply.code === ReplyCode.NO_ERROR) { // 약관 동의 성공                    
                    console.log("term update success");      
                    this.$router.replace('/InviteAdmission');  // 약관 동의 후 회원가입 정보 입력 페이지로 간다                    
                }else { // 약관 동의 에러
                    console.log("term update SYSTEM_ERROR");      
                    utils.aiccMessageBox('확인', res.reply.korMsg, '확인');
                }
            }).catch(err => { // 실패
                console.warn(err);            
            });
        },
        chkRequireTerm(){
            for(let index in this.termsList) {
                if(this.termsList[index].termsMandatoryYn === 'Y'){
                    if(!this.termsList[index].isChecked){
                        this.chkConfirm = false;
                        return;
                    }
                }
            }
            this.chkConfirm = true;
        },
        showTermDetail(value) {
            this.pageInitialData.termsTypeCode = value.termsTypeCode;
            this.pageInitialData.termsName = value.termsName;
            this.pageInitialData.termsContent = value.termsContent;
            this.pageInitialData.isChecked = value.isChecked;
            this.pageInitialData.parentPageId = this.contextPageId;
            this.$refs['termsDetailPopupExt'].open();
        },
        closeDetailPopup() {
            for(let index in this.termsList) {
                if(this.termsList[index].termsTypeCode === this.pageInitialData.termsTypeCode){
                    this.termsList[index].isChecked = this.pageInitialData.isChecked;
                    break;
                }
            }
            this.isAllChk();
            this.chkRequireTerm();
            this.$refs['termsDetailPopupExt'].close();
        },
    },

}
</script>
<style scoped>
::v-deep .ur-checkbox.ur-input.ur-checkbox--medium > .ur-checkbox__label.line-break{
  font-size: 16px;
}
::v-deep .ur-checkbox.ur-input.ur-checkbox--medium > .ur-checkbox__icon.ur-icon.ur-icon--picto.ur-checkbox__unchecked.opus-icon__box{
  font-size: 16px;
}
::v-deep .ur-checkbox.ur-input.ur-checkbox--small > .ur-checkbox__label.line-break{
  font-size: 14px;
}
::v-deep .ur-checkbox.ur-input.ur-checkbox--small > .ur-checkbox__icon.ur-icon.ur-icon--picto.ur-checkbox__unchecked.opus-icon__box{
  font-size: 16px;
}

/* 관리자포털 > 약관관리 메뉴의 editor로 작성한 약관의 배경색은 흰색이나, 약관 동의 화면에서는 투명색으로 변경 */
::v-deep .sun-editor-editable {
  background : transparent;
}
</style>